import React, {Component} from "react";
import {Translate, translate} from "react-i18nify";

import * as rcc from "../../../constants/rcc";
import * as config from "../../../constants/config";
import * as resources from "../../../constants/resources";
import * as formatHelper from "../../../helpers/formatHelper";
import * as validationHelper from "../../../helpers/validationHelper";
import * as modelHelper from "../../../helpers/modelHelper";

import imgStir from "../../../resources/img/svgicons/stir.svg";

import NumericKeyboardInput from "../../global/NumericKeyboardInput";
import Button from "../generic/Button";
import CancelButton from "../generic/CancelButton";
import Modal from "../generic/Modal";

export default class StirCanistersModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedCanisters: [],
            stirringTime: this.props.stirringTime,
            stirringSpeed: this.props.stirringSpeed
        };
    }

    setStirringTimeState = (value) => {
        if (validationHelper.isDecimalValueValid(value)) {
            this.setState({
                stirringTime: validationHelper.formatDecimal(value)
            });
        }
    };

    setStirringSpeedState = (value) => {
        if (validationHelper.isDecimalValueValid(value)) {
            this.setState({
                stirringSpeed: value
            });
        }
    };

    handleCloseModalClick = () => {
        this.props.closeModal();
    };

    handleSelectAllClick = () => {
        this.setState({
            selectedCanisters: this.getEnabledCanisters()
        });
    };

    handleClearClick = () => {
        this.setState({
            selectedCanisters: []
        });
    };

    handleToggleSelectCanisterClick = (event) => {
        let canister = this.getCanisterFromList(Number(event.target.dataset.id));

        if (canister !== null) {
            if (this.isCanisterSelected(canister)) {
                this.setState({
                    selectedCanisters: this.state.selectedCanisters.filter((selected) => selected.id !== canister.id)
                });
            } else {
                this.setState({
                    selectedCanisters: [...this.state.selectedCanisters, canister]
                });
            }
        }
    };

    handleStartStirringClick = () => {
        let canisterIndexes = this.state.selectedCanisters.map((canister) => canister.id);

        if (canisterIndexes.length > 0) {
            this.props.closeModal();
            this.props.stirCanisters(
                canisterIndexes,
                Number(this.state.stirringTime),
                Number(this.state.stirringSpeed)
            );
        }
    };

    handleStirringTimeFocus = (event) => {
        event.target.select();
    };

    handleStirringTimeChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                stirringTime: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleStirringTimeBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value >= rcc.RCC_MINIMAL_STIR_TIME) {
            this.setState({stirringTime: formatHelper.formatDecimal(value)});
            this.props.setStirringTime(parseInt(formatHelper.formatDecimal(value)));
        } else {
            this.setState({stirringTime: rcc.RCC_MINIMAL_STIR_TIME});
            this.props.setStirringTime(rcc.RCC_MINIMAL_STIR_TIME);
        }
    };

    handleStirringSpeedFocus = (event) => {
        event.target.select();
    };

    handleStirringSpeedChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                stirringSpeed: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleStirringSpeedBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value <= 100 && value >= 1) {
            this.setState({stirringSpeed: formatHelper.formatDecimal(value)});
            this.props.setStirringSpeed(parseInt(formatHelper.formatDecimal(value)));
        } else {
            this.setState({stirringSpeed: this.props.stirringSpeed});
        }
    };

    getEnabledCanisters = () => {
        return this.props.canisterList.filter((canister) => canister.enabled);
    };

    getCanisterFromList = (canisterId) => {
        let canister;
        for (canister of this.props.canisterList) {
            if (canister.id === canisterId) {
                return canister;
            }
        }

        return null;
    };

    isCanisterSelected = (canister) => {
        if (this.state.selectedCanisters.length === 0) {
            return false;
        }

        let selectedCanister;
        for (selectedCanister of this.state.selectedCanisters) {
            if (selectedCanister.id === canister.id) {
                return true;
            }
        }

        return false;
    };

    getColorantByCanister = (canister) => {
        let colorant;
        for (colorant of this.props.colorantList) {
            if (canister.colorant.name === colorant.name) {
                return colorant;
            }
        }

        return null;
    };

    getCanisterBoxClass = (canister) => {
        if (this.isCanisterSelected(canister)) {
            return " active";
        }

        return "";
    };

    getCanisterBox = (canister) => {
        let colorant = canister.colorant;
        if (colorant !== null && colorant.rgb === null) {
            colorant = this.getColorantByCanister(canister);
        }

        let colorantRgb = colorant === null || colorant.rgb === null ? config.DEFAULT_RGB : colorant.rgb;
        let colorantName = colorant === null || colorant.name === null ? "" : colorant.name;

        if (!canister.enabled) {
            return (
                <div key={canister.id} className="general-colorant-select-box disabled">
                    <div className="general-colorant-select-box-id" data-id={canister.id}>
                        {canister.id}
                    </div>
                    <div className="general-colorant-select-box-color" style={{backgroundColor: colorantRgb}} />
                    <div className="general-colorant-select-box-name">{colorantName}</div>
                </div>
            );
        }

        return (
            <div
                key={canister.id}
                className={"general-colorant-select-box " + this.getCanisterBoxClass(canister)}
                data-id={canister.id}
                onClick={this.handleToggleSelectCanisterClick}
            >
                <div className="general-colorant-select-box-id" data-id={canister.id}>
                    {canister.id}
                </div>
                <div
                    className="general-colorant-select-box-color"
                    style={{backgroundColor: colorantRgb}}
                    data-id={canister.id}
                />
                <div className="general-colorant-select-box-name" data-id={canister.id}>
                    {colorantName}
                </div>
            </div>
        );
    };

    getCanisterList = () => {
        return (
            <div className="general-wrapper-body general-colorant-select-box-wrapper slim-scroll">
                {this.props.canisterList.map(this.getCanisterBox)}
            </div>
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex font-size-2rem margin-bottom-10 flex-align-center-vertical">
                    <Translate value="stirCanisters.stirringSpeed" />
                    &nbsp;
                    <NumericKeyboardInput
                        type="text"
                        className="general-input primary-input width-60px text-center"
                        value={this.state.stirringSpeed}
                        onFocus={this.handleStirringSpeedFocus}
                        onChange={this.handleStirringSpeedChange}
                        onBlur={this.handleStirringSpeedBlur}
                        disabled={this.props.loggedUser.canNotEdit(resources.SETTINGS_STIRRING_SPEED)}
                        extended={false}
                        setInputState={this.setStirringSpeedState}
                    />
                    <span className="margin-right-auto" style={{marginLeft: "5px"}}>
                        %
                    </span>
                    <Translate value="stirCanisters.stirringTime" />
                    &nbsp;
                    <NumericKeyboardInput
                        type="text"
                        className="general-input primary-input width-60px text-center"
                        value={this.state.stirringTime}
                        onFocus={this.handleStirringTimeFocus}
                        onChange={this.handleStirringTimeChange}
                        onBlur={this.handleStirringTimeBlur}
                        disabled={this.props.loggedUser.canNotEdit(resources.SETTINGS_STIRRING_TIME)}
                        extended={false}
                        setInputState={this.setStirringTimeState}
                    />
                    <span style={{marginLeft: "5px"}}>s</span>
                </div>
                <div className="general-wrapper flex-child">
                    <div className="general-wrapper-header flex margin-bottom-10 flex-align-center-vertical">
                        {translate("stirCanisters.selectCanisters")}
                        <Button
                            className="margin-left-auto"
                            onClick={
                                this.state.selectedCanisters.length < this.getEnabledCanisters().length
                                    ? this.handleSelectAllClick
                                    : this.handleClearClick
                            }
                            label={
                                this.state.selectedCanisters.length < this.getEnabledCanisters().length
                                    ? translate("general.selectAll")
                                    : translate("general.clear")
                            }
                        />
                    </div>
                    {this.getCanisterList()}
                </div>
            </React.Fragment>,
            "flex-column"
        );
    };

    getStartStirringButton = () => {
        if (
            this.state.selectedCanisters.length > 0 &&
            Number(this.state.stirringTime) > 0 &&
            Number(this.state.stirringSpeed) > 0
        ) {
            return (
                <Button
                    onClick={this.handleStartStirringClick}
                    label={translate("serviceActionsSettings.stirCanisters")}
                    svgBefore={imgStir}
                />
            );
        }

        return <Button disabled label={translate("serviceActionsSettings.stirCanisters")} svgBefore={imgStir} />;
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getStartStirringButton()}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.modalId}
                header={modelHelper.buildModalSection(translate("stirCanisters.stirCanisters"))}
                onClose={this.handleCloseModalClick}
                content={this.getContent()}
                footer={this.getFooter()}
            />
        );
    }
}
